import { PaginatedItin } from './../../shared/models/paginated-itin.model';
import { IItin } from './itinerari.model';
import { Injectable } from '@angular/core';
import { dispatch } from '@angular-redux/store';
import { AnyAction } from 'redux';

@Injectable()
export class ItinActionService {

    static ITIN_LIST = 'ITIN_LIST';
    static DELETE_ITIN = 'DELETE_ITIN';
    static ADD_OR_UPDATE_ITIN = 'ADD_OR_UPDATE_ITIN';
    static MODIFY_ITIN = 'MODIFY_ITIN';
    static SET_ITIN_CURRENT = 'SET_ITIN_CURRENT';
    static SEARCH_ITIN = 'SEARCH_ITIN';
    static RESET_FILTERS = 'RESET_FILTERS';
    static TOGGLE_PANEL = 'TOGGLE_PANEL';
    static PAGINATED_ITIN_LIST = 'PAGINATED_ITIN_LIST';

    constructor() {

    }

    @dispatch()
    paginatedItinList = ( data: PaginatedItin ): AnyAction => ({ type: ItinActionService.PAGINATED_ITIN_LIST, payload: data })

    @dispatch()
    itinList = ( data ): AnyAction => ({ type: ItinActionService.ITIN_LIST, payload: data })

    @dispatch()
    addOrUpdateItin = ( data: IItin ): AnyAction => ({ type: ItinActionService.ADD_OR_UPDATE_ITIN, payload: data })

    @dispatch()
    deleteItin = ( data ): AnyAction => ({ type: ItinActionService.DELETE_ITIN, payload: data })

    @dispatch()
    modifyItin = ( data ): AnyAction => ({ type: ItinActionService.MODIFY_ITIN, payload: data })

    @dispatch()
    setItinCurrent = ( data ): AnyAction => ({ type: ItinActionService.SET_ITIN_CURRENT, payload: data })

    @dispatch()
    searchItin = ( data ): AnyAction => ({ type: ItinActionService.SEARCH_ITIN, payload: data })

    @dispatch()
    resetFilters = ( ): AnyAction => ({ type: ItinActionService.RESET_FILTERS })

    @dispatch()
    toggleExpandPanel = ( data ): AnyAction => ({ type: ItinActionService.TOGGLE_PANEL, payload: data })

}
